import React, { ReactNode } from 'react';
import { Box, Modal, IconButton, darken, lighten, SxProps } from '@mui/material';
import { useStyling } from '../Theme';
import { orange } from '@mui/material/colors';
import CloseIcon from '@mui/icons-material/Close';
import { Theme } from '@mui/material/styles';

type SplashScreenModal = {
    open: boolean;
    onClose?: () => void;
    children?: ReactNode;
    sx?: SxProps<Theme>;
};

export default ({ open, onClose, children, sx }: SplashScreenModal) => {
    const { theme, isDarkMode } = useStyling();

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: 'absolute',
                    flexDirection: 'column',
                    maxHeight: { xs: '100%', sm: '90%' },
                    boxShadow: { xs: 0, sm: 24 },
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    display: 'flex',
                    boxSizing: 'border-box',
                    borderRadius: { xs: 0, sm: 1 },
                    zIndex: 10,
                    width: { xs: '100%', sm: '600px' },
                    height: { xs: '100%', sm: '640px' },
                    bgcolor: isDarkMode ? darken(theme.palette.grey[700], 0.5) : lighten(orange[50], 0.7),
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: { xs: '40px', sm: '70px' },
                    gap: 2.5,
                    ...sx
                }}
            >
                {onClose && (
                    <Box sx={{ textAlign: 'end', width: '100%', position: 'absolute', top: '10px', right: '20px' }}>
                        <IconButton size="small" color="inherit" onClick={onClose}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                )}
                {children}
            </Box>
        </Modal>
    );
};
